/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable, catchError, switchMap, throwError } from 'rxjs';
import { AuthentificationService } from '../services/authentication.service';
import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { UserInfo } from '../models/entites/userInfo';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isRefreshing = false; // Flag to track token refresh process

  constructor(private authService: AuthentificationService) {}

  jwtService: JwtHelperService = new JwtHelperService();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const accessToken = this.authService.getAccessToken();
    const userInfo = JSON.parse(localStorage.getItem('UserInfo')!) as UserInfo;

    if (accessToken && userInfo) {
      const decodedAccessToken = this.jwtService.decodeToken(accessToken);
      const expirationDateUTC = new Date(decodedAccessToken.exp * 1000);

      if (new Date() >= expirationDateUTC) {
        // Check if token refresh is already in progress
        if (!this.isRefreshing) {
          this.isRefreshing = true; // Set flag to indicate token refresh in progress

          // Call refreshToken method and return the new Observable
          return this.authService.refreshToken().pipe(
            switchMap((newToken: any) => {
              this.isRefreshing = false; // Reset flag after token refresh
              request = request.clone({
                setHeaders: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${newToken}`
                },
                withCredentials: false
              });
              return next.handle(request); // Proceed with the updated request
            }),
            catchError((error: any) => {
              this.isRefreshing = false; // Reset flag on error
              if (accessToken && userInfo && error.status === 401) {
                this.authService.logout(); // Logout user if token refresh fails
              }
              return throwError(error);
            })
          );
        }
      } else {
        // Token is valid, proceed with the request
        request = request.clone({
          setHeaders: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`
          },
          withCredentials: false
        });
      }
    }

    return next.handle(request).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 401) {
            if (accessToken && userInfo) {
              // Logout user if token is not valid or expired
              this.authService.logout();
            }
          }
        }
        return throwError(error);
      })
    );
  }
}
